import styled from 'styled-components';

export const ScLootboxButton = styled.button`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  text-align: center;
  border-radius: 40px;
  padding: 10px 16px;
  color: #744500;
  background: linear-gradient(180deg, #ffad01 0%, #ffe225 100%);
  font-weight: 700;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.01em;
  text-transform: uppercase;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 40px;
    padding: 2px;
    background: linear-gradient(
      180deg,
      #ee8203 0%,
      rgba(255, 255, 255, 0.4) 79.69%
    );
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }

  &:hover {
    background:
      linear-gradient(0deg, rgba(255, 255, 255, 0.4), rgba(255, 255, 255, 0.4)),
      linear-gradient(180deg, #ffad01 0%, #ffe225 100%);
  }
`;
